export enum TransactionAction {
  NotifyAndSendToGL = "notify_and_send",
  Notify = "notify",
  SendToGL = "send_to_gl",
  ExportAll = "export_all",
  ExportSelected = "export_selected",
}

export const csvHeaders = [
  { label: "fund", key: "fund" },
  { label: "investor", key: "investor" },
  { label: "amount_owed", key: "amount" },
  { label: "amount_paid", key: "amountPaid" },
  { label: "cash_received", key: "cashReceived" },
  { label: "date_of_receipt", key: "receiptDate" },
  { label: "notified", key: "notified" },
];
